import RestrictedUserRoute from "discourse/routes/restricted-user";

export default class PreferencesUsers extends RestrictedUserRoute {}
